// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7299aa2e","455":"0583ce9b","977":"a7f4cbca"}[chunkId] + ".chunk.js";
};